export default __webpack_public_path__ + "static/media/logo-light-short.5e3961d9.png";